import script from "./AEtapas.vue?vue&type=script&lang=ts&setup=true"
export * from "./AEtapas.vue?vue&type=script&lang=ts&setup=true"

import "./AEtapas.vue?vue&type=style&index=0&id=b7e18aba&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7e18aba"]])

export default __exports__